export function sanityCheck(slugValue) {
  return slugValue.replace(/[^\\.a-zA-Z0-9_-]+/g, '');
}
